<template>
  <div class="wrapper">
    <div class="checkout-container">
      <h1>Provjera kupnje i plaćanje</h1>
      <div class="checkout">
        <div class="buyer-info">
          <user-container :user="user" @refetchUser="handleRefetchUser" />
          <store-payment-methods class="section-container" :buyer="buyer" />
          <buyer-form class="section-container" :buyer="buyer" :vs="$v" />
          <user-permissions
            class="section-container"
            :vs="$v"
            :buyer="buyer"
            :organization="organization"
          />
          <div class="button-container">
            <main-button color="#333" style="border-radius: 0" :disabled="!buyer.paymentMethod && order.reduce((sum, item) => sum + Number(item.price), 0) > 0" @click="handleSubmit">
              potvrdi narudžbu
            </main-button>
          </div>
        </div>
        <div class="cart-timer">
          <store-timer :start-time="startedAt" local-storage-item="organizationStoreOrder" />
          <shopping-cart
            ref="shoppingCart"
            :show-next="false"
            :order="order"
            class="shopping-cart"
            @edit="$emit('edit')"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserContainer from '@/components/accreditations/organization-store/user/UserContainer.vue'
import { email, required, sameAs } from 'vuelidate/lib/validators'
import UserPermissions from '@/components/accreditations/organization-store/store-checkout/components/UserPermissions.vue'
import ShoppingCart from '@/components/accreditations/organization-store/shopping-cart/ShoppingCart.vue'
import BuyerForm from '@/components/accreditations/organization-store/store-checkout/components/BuyerForm.vue'
import StorePaymentMethods from '@/components/accreditations/organization-store/store-checkout/components/StorePaymentMethods.vue'
import StoreTimer from '@/components/accreditations/organization-store/store-checkout/components/StoreTimer.vue'
import { submitGuard } from '@/utils'

export default {
  name: 'checkout-container',
  components: {
    StoreTimer,
    StorePaymentMethods,
    BuyerForm,
    ShoppingCart,
    UserPermissions,
    UserContainer,
  },
  props: {
    user: {
      type: Object,
      default: null,
    },
    buyer: {
      type: Object,
      default: null,
    },
    organization: {
      type: Object,
      default: null,
    },
    order: {
      type: Array,
      default: () => [],
    },
    startedAt: {
      type: String,
    },
  },
  validations() {
    return {
      buyer: {
        firstName: { required },
        lastName: { required },
        email: { required, email },
        address: { required },
        city: { required },
        postalCode: { required },
        country: { required },
        mobile: { required },
        acceptTermsAndConditions: {
          sameAs: sameAs(() => true),
        },
      },
    }
  },
  methods: {
    handleRefetchUser() {
      this.$emit('refetchUser')
    },
    handleSubmit() {
      if (!this.buyer.paymentMethod && this.$refs.shoppingCart.getTotalPrice() > 0) return
      submitGuard(this, () => {
        this.$emit('submit')
      })
    },
  },
}
</script>

<style scoped>
.wrapper {
  display: flex;
  justify-content: center;
  padding: 2rem 7rem;
}
.checkout-container {
  display: flex;
  flex-direction: column;
  gap: 2.5rem;
}
h1 {
  color: #333;
  font-variant-numeric: lining-nums proportional-nums;
  font-family: Raleway;
  font-size: 36px;
  font-style: normal;
  font-weight: 800;
  line-height: 120%; /* 43.2px */
  letter-spacing: -1.08px;
}
.checkout {
  display: flex;
  gap: 1.5rem;
}
.button-container {
  display: flex;
  justify-content: flex-end;
  padding: 1.5rem;
  border-top: 2px solid #333;
  border-bottom: 2px solid #333;
  background: #f5f5f5;
}
.section-container {
  border-top: 2px solid #333;
  padding: 2rem 1.5rem 2.5rem;
}
.buyer-info {
  flex: 2;
  max-width: 800px;
}
.cart-timer {
  flex: 1;
  max-width: 400px;
}
@media screen and (max-width: 1024px) {
  .buyer-info {
    max-width: 100%;
  }
  .checkout {
    flex-direction: column;
  }
  .wrapper {
    padding: 2rem 2rem;
  }
  .cart-timer {
    max-width: 100%;
  }
}
@media screen and (max-width: 800px) {
  .wrapper {
    padding: 2rem 0;
  }
}
</style>
